
















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import { ApplicationState, FacilityList } from "@/models";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { GroupData } from "@/models/business-rules/GroupData";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "GroupFacilityView"
})

export default class GroupFacilityView extends Vue {
  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @State("application") private readonly application!: ApplicationState;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;
  @businessRules.Action("handleGroupName") public handleGroupName!: (groupName: string) => void;
  @businessRules.Action("handleGroupDescription") public handleGroupDescription!: (groupDescription: string) => void;
  @businessRules.Action("handleGroupSaved") public handleGroupSaved!: (status: boolean) => void;
  @businessRules.Action("handleSelectedFacilities") public handleSelectedFacilities!: (facilities: FacilityList[]) => void;
  @businessRules.Action("handleResetRules") public handleResetRules!: () => void;

  // ===== Data ===== //
  public editGroupName = false;
  public editGroupDescription = false;

  // ===== Methods ===== //
  public handleAddRule(): void {
    this.handleResetRules();
    this.handleCurrentStep(3);
  }
  public handleEdit(editItem: string): void {
    if (editItem === "name") {
      this.editGroupName = !this.editGroupName;
    } else {
      this.editGroupDescription = !this.editGroupDescription;
    }
  }
  public handleRemoveFacility(facility: FacilityList): void {
    const filteredFacilities = this.selectedFacilities.filter(facilities => facilities.id !== facility.id);
    this.handleSelectedFacilities(filteredFacilities);
    this.handleGroupSaved(false);
  }
  public handleUpdateGroupSaved(): void {
    this.handleGroupSaved(false);
  }
  @Watch("groupDesc", { deep: true })
  public handleGroupDesc(groupDesc: string) {
    this.handleGroupDescription(groupDesc);
  }

  // ===== Computed ===== //
  get availableFacilities(): FacilityList[] {
    return this.application.facilitiesList.filter(facility => facility.bre_group_id === null);
  }
  get groupDesc(): string {
    return this.businessRules.selectedGroup
      ? this.businessRules.selectedGroup!.description : this.businessRules.createGroup!.description;
  }
  set groupDesc(newVal: string) {
    this.handleGroupDescription(newVal);
  }
  get groupName(): string {
    return this.businessRules.selectedGroup
      ? this.businessRules.selectedGroup!.name : this.businessRules.createGroup!.name;
  }
  set groupName(newVal: string) {
    this.handleGroupName(newVal);
  }
  get selectedFacilities(): FacilityList[] {
    return this.businessRules.selectedFacilities ? this.businessRules.selectedFacilities : [];
  }
  set selectedFacilities(newVal: FacilityList[]) {
    this.handleSelectedFacilities(newVal);
  }
  get selectedGroup(): GroupData {
    return this.businessRules.selectedGroup!;
  }
  get sameGroupName(): boolean {
    return this.selectedGroup
      ? this.businessRules.createGroup!.name === this.selectedGroup!.name
      : false;
  }
  get sameGroupDescription(): boolean {
    return this.selectedGroup
      ? this.businessRules.createGroup!.description === this.selectedGroup!.description
      : false;
  }
}

